import React, { useEffect, useState } from "react";
import "./style.css";
import { Navbar } from "../../components/Navbar";
import TeamContent from "./components/team";
import BillingContent from "./components/billing";
import ProfileContent from "./components/profile";
import CompanyContent from "./components/company";
import IntegrationsContent from "./components/integration";
import AgentManager from "./components/AgentManager";
import { useUserInfo } from "../../context/user";
import Balance from "./components/Balance";
import Files from "./components/Files";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppServices } from "../../hook/services";
import ApiAccess from "./components/ApiAccess";
import Pricing from "./components/Pricing/Pricing";
import ResetContext from "./components/ResetContext";
import DataInterpreter from "./components/DataInterpreter";
import AddUserModal from "./components/team/component/AddUserModal";
import Icon from "../../components/icons";
import { useUsersContext } from "../../context/usersContext";
import Wallet from "./components/wallet";
import Guardrails from "./components/Guardrails";
import Webhooks from "./components/Webhooks";

function Settings() {
  const AppService = useAppServices();
  const activeplans = useUserInfo()[12];
  const logoutUser = useUserInfo()[2];
  const checkIfGhlUser = useUserInfo()[9];
    const agencyData = useUserInfo()[11];

  const [activeTab, setActiveTab] = useState("");
  const [limit, setLimit] = useState(false);
  const [pricingHeading, setPricingHeading] = useState("");
  const location = useLocation(); // Hook to get current location
  const navigate = useNavigate();
  const userActiveLocation = useUserInfo()[4];
  const userInfo = useUserInfo()[0];
  const [openTeamModal, setOpenTeamModal] = useState(false);
  const { locationUsers, products, agency } = useUsersContext();

  const agentShow = useUserInfo()[18];
  const not_in_plan_and_saas_modere_billing = [
    "Knowledge Base",
    "Data Interpreter",
    "Integrations",
    "API Access",
    "Pricing",
    "Billing",
    "Profile",
    "Team",
    "Agents",
    "Reset Context",

  ];
  const activePlan = products?.find((item) => item?.activePlan === true)

  let sidebarMenus = [
    { title: "Integrations", content: <IntegrationsContent /> },
    { title: "Webhooks", content: <Webhooks /> },

    { title: "API Access", content: <ApiAccess /> },
    { title: "Knowledge Base", content: <Files setActiveTab={setActiveTab} /> },
    {
      title: "Data Interpreter",
      content: <DataInterpreter setActiveTab={setActiveTab} />,
    },
    // { title: "Company", content: <CompanyContent /> },
    { title: "Guardrails", content: <Guardrails /> },

    { title: "Team", content: <TeamContent setActiveTab={setActiveTab} setPricingHeading={setPricingHeading} /> },
    ...(Object.keys(activePlan?.rebilling || {}).length > 0 && activePlan?.rebilling?.ai_active === true ? [{ title: "Wallet", content: <Wallet /> }] : []),
    ...(userActiveLocation?.type !== 'free' ? [{ title: "Billing", content: <Balance setActiveTab={setActiveTab} /> }] : []),
    // { title: "Agents", content: <AgentManager /> },
    { title: "Profile", content: <ProfileContent /> },
    ...(userActiveLocation?.type !== 'free' && (activePlan?.isenable_account || activePlan?.developer_plan) ? [{
      title: "Pricing",
      content: (
        <Pricing
          limit={limit}
          pricingHeading={pricingHeading}
          setActiveTab={setActiveTab}
        />
      ),
    }] : []),
  ];
  if (checkIfGhlUser) {
    sidebarMenus = sidebarMenus
      .filter((item) => item.title !== "Team")
      .filter((menu) => menu.title !== "Profile");
  }

  const filteredByGhlUser = sidebarMenus?.filter((menu) => {
    if (userActiveLocation?.email === userInfo?.email) return menu;
    return menu.title !== 'Wallet'
  });

  useEffect(() => {
    setActiveTab(filteredByGhlUser[0].title);
  }, []);

  // Render the sidebar menu items
  const renderSidebarMenus = () => {
    return filteredByGhlUser.map((menu, index) => (
      <li
        key={index}
        className={`settingSidebar-menu-item ${menu.title === activeTab ? "active" : ""
          }`}
      >
        <button
          onClick={() => setActiveTab(menu.title)}
          className="settingSidebar-menu-link"
        >
          {menu.title}
        </button>
      </li>
    ));
  };

  // Render the content based on the active tab
  const renderContent = () => {
    const selectedMenu = filteredByGhlUser.find(
      (menu) => menu.title === activeTab
    );
    return selectedMenu ? <div>{selectedMenu.content}</div> : null;
  };

  // Step 1: Update active tab based on the URL (e.g., if URL includes 'billing', set active tab to 'Billing')
  useEffect(() => {
    // Only execute the effect if 'Billing' is in the filteredByGhlUser
    if (filteredByGhlUser.some((menu) => menu.title === "Billing")) {
      const hash = location.hash; // Get the hash part of the URL (e.g., #billing)
      if (hash === "#billing") {
        setActiveTab("Billing");
      }
    }
    if (location.state) {
      setActiveTab(location.state?.tab);
      setPricingHeading(location.state?.text || "");
      !location.state?.text && setLimit(true);
      navigate(location.pathname, { replace: true });
    }
  }, [location.pathname, filteredByGhlUser]);

  return (
    <div
      className="m-auto"
      style={{
        background: agencyData?.Customization?.body_bg
          ? agencyData?.Customization?.body_bg
          : "#fff",
      }}
    >
      <Helmet>
        <title>
          {agencyData?.Customization?.setting_m_title
            ? agencyData?.Customization?.setting_m_title
            : "Settings"}
        </title>
        <meta
          name="description"
          content={`${agencyData?.Customization?.setting_m_description}`}
        />
        {agencyData?.Customization?.gtag}
      </Helmet>
      <Navbar />
      <div className="settings-container relative px-5 h-full">
        {/* Sidebar */}
        <div className="sidebarWrapper min-w-[191px]">
          <div className="settingSidebar">
            <ul className="settingSidebar-menu mt-6">
              {renderSidebarMenus()}
              {agency?.help_centre_link && (
                <li className="settingSidebar-menu-item">
                  <a
                    href={agency?.help_centre_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="settingSidebar-menu-link"
                  >
                    {agency?.help_centre_label || "Help Centre"}
                  </a>
                </li>
              )}
              {!checkIfGhlUser ? (
                <>
                  <li className="settingSidebar-menu-item">
                    <button
                      onClick={() => logoutUser()}
                      className="settingSidebar-menu-link"
                    >
                      Logout
                    </button>
                  </li>
                </>
              ) : (
                <></>
              )}
            </ul>
          </div>
          <div
            style={{
              width: "100%",
              position: "absolute",
              bottom: "100px",
              right: 0,
              left: 0,
              background: "#fff",
              paddingRight: "20px",
            }}
          >
            <div
              className="border border-black px-1 py-3 text-center cursor-pointer"
              onClick={() => setActiveTab('Team')}
            >
              <span className="flex">
                <Icon id={"AddTeamMember"} />
                <span className="text-[14px] ml-2 whitespace-nowrap">Invite Team Members </span>
              </span>
            </div>
          </div>
          {openTeamModal && (
            <AddUserModal
              isModalOpen={openTeamModal}
              justCloseIt={() => setOpenTeamModal(false)}
              userActiveLocation={userActiveLocation}
              activeplans={activeplans}
              locationUsers={locationUsers}
              setActiveTab={setActiveTab}
            />
          )}
        </div>

        {/* Main Content */}
        <div className="main-content">
          {/* Render the content based on the active tab */}
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default Settings;
